module.exports = __webpack_public_path__ + "img/lqdange.425716c2.svg";